import { fmt } from "@/lib/format";

// 사용자 드로어의 "충전 내역" 탭(2026-07-21) — 매출 탭의 전체 원장(ChargeHistory.jsx)과
// 같은 문법(실결제/수기지급 배지·이벤트 배지·환불 표시)이지만 이 사용자 것만. 데이터는
// userDetail 응답의 charges 를 그대로 사용 — 선택된 기간(range)의 거래만 담겨 있다.
export default function UserChargeHistory({ charges }) {
  const rows = charges || [];
  if (rows.length === 0) {
    return (
      <div className="rounded-lg border border-ink-100 p-6 text-center text-sm text-ink-400">
        선택한 기간에 충전·지급 내역이 없습니다.
      </div>
    );
  }

  const payments = rows.filter((c) => c.kind === "payment" && !c.refunded);
  const revenueKrw = payments.reduce((s, c) => s + (c.amountKrw || 0), 0);
  const manualRows = rows.filter((c) => c.kind === "manual");
  const manualNc = manualRows.reduce((s, c) => s + (c.amountNc || 0), 0);

  return (
    <div>
      <div className="mb-2 grid grid-cols-2 gap-2">
        <MiniStat label="실결제" value={`${fmt.int(payments.length)}건`} sub={fmt.krw(revenueKrw)} />
        <MiniStat label="수기 지급/회수" value={`${fmt.int(manualRows.length)}건`} sub={`${fmt.nc(manualNc)} 크레딧`} />
      </div>
      <div className="overflow-x-auto rounded-lg border border-ink-100">
        <table className="min-w-full text-sm">
          <thead className="bg-ink-50">
            <tr>
              <th className="px-3 py-2 text-left text-xs font-medium text-ink-500">일시 (KST)</th>
              <th className="px-3 py-2 text-left text-xs font-medium text-ink-500">구분</th>
              <th className="px-3 py-2 text-right text-xs font-medium text-ink-500">결제 금액</th>
              <th className="px-3 py-2 text-right text-xs font-medium text-ink-500">지급 크레딧</th>
              <th className="px-3 py-2 text-left text-xs font-medium text-ink-500">수단 / 사유</th>
              <th className="px-3 py-2 text-left text-xs font-medium text-ink-500">환불</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-ink-100">
            {rows.map((c, i) => (
              <tr key={`${c.createdAt}-${i}`} className={`hover:bg-ink-50 ${c.refunded ? "opacity-60" : ""}`}>
                <td className="whitespace-nowrap px-3 py-2 tabular-nums text-ink-600">{fmt.kstDateTime(c.createdAt).slice(0, 16)}</td>
                <td className="whitespace-nowrap px-3 py-2">
                  {c.kind === "payment" ? (
                    <span className="rounded bg-emerald-50 px-1.5 py-0.5 text-xs font-medium text-emerald-700">실결제</span>
                  ) : (
                    <span className="rounded bg-amber-50 px-1.5 py-0.5 text-xs font-medium text-amber-700">
                      {c.amountNc < 0 ? "수기 회수" : "수기 지급"}
                    </span>
                  )}
                </td>
                <td className="whitespace-nowrap px-3 py-2 text-right tabular-nums font-medium text-ink-900">
                  {c.kind === "payment" ? fmt.krw(c.amountKrw) : <span className="text-ink-300">—</span>}
                </td>
                <td className="whitespace-nowrap px-3 py-2 text-right tabular-nums text-ink-500">
                  {fmt.nc(c.amountNc)}
                  {c.promo && (
                    <span className="ml-1 rounded bg-brand-50 px-1 py-0.5 text-[10px] font-medium text-brand-700">이벤트</span>
                  )}
                </td>
                <td className="max-w-[12rem] truncate whitespace-nowrap px-3 py-2 text-ink-500">
                  {c.kind === "payment" ? (c.method || "—") : (c.reason || "—")}
                </td>
                <td className="whitespace-nowrap px-3 py-2">
                  {c.refunded ? (
                    <span className="rounded bg-red-50 px-1.5 py-0.5 text-xs font-medium text-red-600">
                      {c.refundedAt ? fmt.kstDateTime(c.refundedAt).slice(0, 16) : "환불됨"}
                    </span>
                  ) : (
                    <span className="text-xs text-ink-300">—</span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="mt-2 text-xs text-ink-400">
        수기 지급은 매출에 포함되지 않습니다. "이벤트" 배지 = 결제액보다 많은 크레딧을 받은 결제(×2 프로모 등).
      </p>
    </div>
  );
}

function MiniStat({ label, value, sub }) {
  return (
    <div className="rounded-lg border border-ink-200 bg-white p-2.5">
      <div className="text-[11px] text-ink-500">{label}</div>
      <div className="mt-0.5 text-sm font-semibold tabular-nums text-ink-900">{value}</div>
      {sub && <div className="mt-0.5 truncate text-[11px] tabular-nums text-ink-400">{sub}</div>}
    </div>
  );
}
